<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardVS :cardContent="content" @updateUser="updateUser" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardVS from "../../components/template/Chinese1/CardVS";
import "../../assets/scss/_chineseStyle.scss";
import "../../assets/scss/_chineseModalCustom.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";
export default {
  components: { CardVS, LoadingMDL },
  name: "LKT04",
  data() {
    return {
      code: "",
      lang: "",
      content: {},
      CheckWidth: window.innerWidth.toString(),
      courseCode: "",
      courseId: "",
      courseSection: "",
      startTime: "",
      condition: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      getUserTemplate: "template/getUserTemplate",
    }),
  },
  watch: {
    allCourse: function(val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseId,
          template: val._id,
          section: this.courseSection,
        });
      }
    },
    getUserTemplate: function(val) {
      this.condition =
        typeof val.data.condition.criteriaType == "undefined" ||
        val.data.condition.criteriaType.length == 0
          ? []
          : [
              {
                criteria: val.data.condition.criteriaType[0].criteria._id,
                val: val.data.condition.criteriaType[0].val,
              },
            ];
      this.loading = false;
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseId;
    body.templateCode = "LKT04-" + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
    // this.$store.dispatch("courses/fetchCourseTopic", this.courseCode);
  },
  created() {
    this.lang = this.$store.state.language.language;
    this.courseCode = this.$store.getters["necessary/getLerningCourse"].code;
    this.courseId = this.$store.getters["necessary/getLerningCourse"]._id;
    this.startTime = this.$helpers.getDateFormat();
  },
  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    updateUser(path) {
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseId,
        template: this.content._id,
        section: this.$store.getters["necessary/getLerningCourse"].groups[0]
          .code,
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
      this.$router.push(path);
    },
  },
};
</script>
<style></style>
